#import "../../../../core/schema/public/fragments/OrderForCustomerFull.graphql"

query (
  $nextToken: String
) {
  listOrdersByCustomer(
    nextToken: $nextToken
  ) {
    items {
      ...OrderForCustomerFull
    }
    nextToken
  }
}
